import React, { useEffect } from "react";
import ApplicationApprovalComponentLegacy from "../../../components/applicationComponents/legacy/applicationApproval/ApplicationApprovalComponentLegacy";
import { useApplicationContext } from "../../../components/applicationComponents/context/applicationContext";

export default function ApplicationApprovalPageLegacy() {
  const { setHeaderText } = useApplicationContext();
  useEffect(() => {
    setHeaderText({
      value: "Application Approval",
      icon: "view-app-icon mr-3 mt-0",
    });
  }, []);
  return (
    <>
      <ApplicationApprovalComponentLegacy disabled={false} />
    </>
  );
}
